import { Spin } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  filterAppointmentsInQueue,
  filterPendingAppointments
} from '../../../utils/appointmentsUtils'
import InternalHeader from '../../MainLayout/InternalHeader/InternalHeader'
import TimeSlotMessage from '../TimeSlotMessage'
import cx from 'classnames'

import './Page.css'
import $t from '../../../i18n'

const Page = ({
  image,
  title,
  subtitle,
  className = '',
  children,
  displayManageFamily = false,
  displayProfile = false,
  displayEnrollmentYearsDropdown = false,
  loading,
  fullWidth = false,
  onBack,
  hideAlertBanner,
  manageFamilyProps,
  AdditionalActionsComponent
}) => {
  const appointments = useSelector(state => state.appointments?.appointments)
  const userDetails = useSelector(state => state.profile?.userDetails)
  const myAppointments = appointments.filter(appointment =>
    appointment?.participants?.find(
      p => p?.type === 'patient' && p?.id === `p_${userDetails?.id}`
    )
  )

  const isAppointmentInQueue =
    filterAppointmentsInQueue(myAppointments).length > 0
  const isPendingAppointment =
    filterPendingAppointments(myAppointments).length > 0

  const isAlertBunnerDisplay =
    !hideAlertBanner && (isAppointmentInQueue || isPendingAppointment)

  return (
    <div
      className={
        isAlertBunnerDisplay
          ? 'responsive-page with-alert-bunner ' + className
          : 'responsive-page ' + className
      }
    >
      {isAlertBunnerDisplay && (
        <div className='appointment-timer-banner alert-banner'>
          <TimeSlotMessage className='alert-banner-text' />
        </div>
      )}
      <div className='page-header'>
        {(displayManageFamily ||
          displayProfile ||
          displayEnrollmentYearsDropdown) && (
          <InternalHeader
            displayManageFamily={displayManageFamily}
            {...manageFamilyProps}
            hideProfile={!displayProfile}
            displayEnrollmentYearsDropdown={displayEnrollmentYearsDropdown}
          />
        )}
        {image && <img className='page-img' src={image} alt='' />}
        <div className='page-header-title-with-actions'>
          <div>
            {title && (
              <>
                {onBack && (
                  <div className='back-btn' onClick={onBack}>
                    <i className='icon icon-arrow-bold-left' />
                    {$t('common.back')}
                  </div>
                )}
                {title && <h1 className='title'> {title} </h1>}
              </>
            )}
            {subtitle && <h2 className='subtitle'> {subtitle} </h2>}
          </div>
          {AdditionalActionsComponent && (
            <div className='additional-actions-component'>
              {AdditionalActionsComponent}
            </div>
          )}
        </div>
      </div>
      <div className={cx('page-content', { 'full-width': fullWidth })}>
        {loading ? <Spin size='large' /> : children}
      </div>
    </div>
  )
}

export default Page
